import React from "react";

const SalesInvoiceRegister = () => {
  return <div>SalesInvoice</div>;
};

export default SalesInvoiceRegister;
